import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdministrativeConsolidatedSchedulesTransferService } from 'src/app/services/administrative-consolidated-schedules-transfer.service';
import { LoginService } from 'src/app/services/login.service';

export interface InaptTransferModalData {
  doctorName: string | null;
  specialtyName: string | null;
  amount: number | null;
  indicationId: number | null;
  consolidatedScheduleId: string;
}

@Component({
  selector: 'app-inapt-transfer-modal',
  templateUrl: './inapt-transfer.modal.html',
  styleUrls: ['./inapt-transfer.modal.scss'],
})
export class InaptTransferModalComponent {
  form: FormGroup;
  loading = false;

  constructor(
    private readonly dialogRef: MatDialogRef<InaptTransferModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InaptTransferModalData,
    private readonly fb: FormBuilder,
    private readonly transferService: AdministrativeConsolidatedSchedulesTransferService,
    private readonly loginService: LoginService
  ) {
    this.form = this.fb.group({
      observation: [
        '',
        [Validators.required, Validators.minLength(3), Validators.maxLength(500)],
      ],
    });
  }

  get formattedAmount(): string {
    if (this.data.amount === null || this.data.amount === undefined) return '-';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(Number(this.data.amount));
  }

  close(): void {
    if (this.loading) return;
    this.dialogRef.close();
  }

  submit(): void {
    if (this.loading) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const observation = this.form.value.observation?.trim() ?? '';
    if (!observation) {
      this.form.get('observation')?.setErrors({ required: true });
      return;
    }

    this.loading = true;
    this.transferService
      .transferUnavailable(this.data.consolidatedScheduleId, observation)
      .subscribe({
        next: () => this.dialogRef.close('success'),
        error: (error) => this.handleError(error),
      });
  }

  private handleError(error: any): void {
    this.loading = false;
    this.loginService.showMessage(this.getFriendlyError(error), 5000);
    this.dialogRef.close();
  }

  private getFriendlyError(error: any): string {
    const status = error?.status;
    const backendMessage =
      error?.error?.message ||
      (typeof error?.error === 'string' ? error.error : null);

    if (status === 404) {
      return 'Serviço de pagamentos indisponível no momento. Tente novamente em instantes ou contate o suporte.';
    }

    if (status >= 500) {
      return 'Erro temporãrio no serviço de pagamentos. Tente novamente em alguns instantes.';
    }

    if (status === 400 || status === 422) {
      return (
        backendMessage ||
        'Não foi possível processar o pagamento manual. Verifique os dados e tente novamente.'
      );
    }

    return (
      backendMessage ||
      'Falha ao iniciar o pagamento manual. Tente novamente ou contate o suporte.'
    );
  }
}
